import { render, staticRenderFns } from "./ViewPendingMerchant.vue?vue&type=template&id=3da385db&scoped=true&"
import script from "./ViewPendingMerchant.vue?vue&type=script&lang=js&"
export * from "./ViewPendingMerchant.vue?vue&type=script&lang=js&"
import style0 from "./ViewPendingMerchant.vue?vue&type=style&index=0&id=3da385db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da385db",
  null
  
)

export default component.exports